import React, { Component } from "react";
import { fabric } from "fabric";
import pako from "pako";
import { Button, Menu, Layout, Tooltip, Icon, Typography, notification } from "antd";
import debounce from "lodash/debounce";
import i18n from "i18next";
import { connect } from "react-redux";

import {
  setCategories,
  setSeatSpacing,
  setRowSeatSize,
  setRowSpacing,
  setRoundTableSeats,
  setRoundTableRadius,
  setRectTableSeats,
  setRectTableDimensions,
  designerPropertiesSlice,
  setSpinning,
  setAvailableToPublish,
  openModal,
  setShowZoomWatermark
} from "../redux/designerPropertiesSlice";
import { actionSaveMap } from "../constants/actions";
import { mapStatus } from "../constants/status";

import "../assets/libs/fontawesome-5.2.0/css/all.css";
import "../assets/styles/index.scss";

import { Header } from "../components/editor/Header";
import ToolBar from "../components/editor/ToolBar";
import { Canvas } from "../components/canvas";
import PropertyBar from "../components/editor/PropertyBar";
import Preview from "../components/editor/Preview";
import { code } from "../constants";
import Footer from "../components/editor/Footer";
import service from "../service";
import { getDuplicates, getNotCategorized, getSeats, getUnlabeled } from "../utils/SeatUtil"
import { Modal, Select, Avatar } from 'antd';
import { ObjectSuperTypesEnum } from "../enums";

const propertiesToInclude = [
  "id",
  "name",
  "locked",
  "file",
  "src",
  "link",
  "tooltip",
  "layout",
  "workareaWidth",
  "workareaHeight",
  "videoLoadType",
  "autoplay",
  "shadow",
  "muted",
  "loop",
  "code",
  "icon",
  "userProperty",
  "configuration",
  "superType",
  "points",
  "svg",
  "loadType",
];

const defaultOption = {
  fill: "rgba(255, 255, 255, 0)",
  stroke: "rgba(0, 0, 0, 1)",
  strokeUniform: true,
};

const validTypes = [
  ObjectSuperTypesEnum.Row,
  ObjectSuperTypesEnum.RectTable,
  ObjectSuperTypesEnum.RoundTable,
  ObjectSuperTypesEnum.PolygonZone
];

class MapEditor extends Component {
  state = {
    selectedItem: null,
    selectedTool: null,
    zoomRatio: 1,
    preview: false,
    loading: false,
    progress: 0,
    action: "",
    tools: {},
    objects: {},
    objCanvasPreviewOver: {},
    cursorName: "",
    onClickCanvas: false,
    itemOnCanvas: "",
    selectedProperties: "default",
    map: {},
    validation: {
      numberSeats: 0,
      duplicates: [],
      notCategorized: [],
      unlabeled: []
    },
    maps: [],
    selectedMap: {}
  };

  componentDidMount() {
    this.props.dispatch(setSpinning(true));
    this.setState({ selectedItem: null });
    this.setState({ selectedTool: null });
    this.shortcutHandlers.esc();
    this.initScript();
  }

  componentWillUnmount() {
    this.props.dispatch(setShowZoomWatermark(false));
  }

  initScript = () => {
    window.redseats.setSettigs(process.env.REACT_APP_ENVIROMENT, "Designer");
    if (window.redseats.publicKey) this.init();
    else window.redseats.component.callback = this.init;
  };

  init = async () => {
    const map = await service.map.get();
    await this.loadMap(map, actionSaveMap.updateData);
    this.props.dispatch(setSpinning(false));
  };

  loadMap = async (map, action) => {
    this.setPropertiesInStore(map);
    this.setState({ map: map });
    if (map.key) {
      const mapCanvas = JSON.parse(map.layout);
      await this.handlers.onLoad(mapCanvas);
      await this.saveMap(action);
      this.setProperties();
    } else this.props.dispatch(setSpinning(false));
  }

  setPropertiesInStore = (map) => {
    this.props.dispatch(setCategories(map.categories));
  };

  saveMap = async (action) => {
    let result = undefined;
    const successfulStatus = [200, 201];
    let { map } = this.state;
    switch (action) {
      case actionSaveMap.create:
        result = await service.map.create(map);
        break;
      case actionSaveMap.updateData:
        result = await service.map.updateData(map);
        break;
      case actionSaveMap.updateLayout:
        this.setState({
          action: "saving",
        });
        const jsonString = this.handlers.onExportToJson();
        const compressedMap = pako.gzip(jsonString);
        const formData = new FormData();
        formData.append('key', map.key);
        formData.append('layout', new Blob([compressedMap], { type: 'application/gzip' }), `${map.key}.json.gz`);

        result = await service.map.updateLayout(formData);
        break;
      case actionSaveMap.publish:
        this.setState({
          action: "publishing",
        });
        let dataUrl = this.canvasRef.handler.getCanvasImage();
        map.imageUrl = dataUrl.split(',')[1];
        result = await service.map.publish(map);
        break;
    }

    if (successfulStatus.includes(result.statusCode)) {
      this.setState({
        map: { ...result.data, layout: map.layout, categories: map.categories },
        action: "",
      });
      if (action == actionSaveMap.create)
        window.redseats.onMapCreated(result.data.key);
    } else alert("Error al guardar mapa");
  };

  canvasHandlers = {
    onAdd: (target) => {
      this.forceUpdate();
      this.onChangeCanvas();
      if (target.type === "activeSelection") {
        this.canvasHandlers.onSelect(null);
        return;
      }
      this.canvasRef.handler.select(target);
    },
    onSelect: (target) => {
      const { selectedItem } = this.state;
      if (
        target &&
        target.id &&
        target.id !== "workarea" &&
        target.type !== "activeSelection"
      ) {
        if (selectedItem && target.id === selectedItem.id) return;
        this.setState({ selectedProperties: "node", selectedItem: target });
        return;
      }
      if (target && target.type === "activeSelection") {
        this.setState({ selectedProperties: "activeSelection", selectedItem: target });
        return;
      }
      this.setState({ selectedProperties: "default" });
      this.setState({ selectedItem: null });
    },
    onRemove: () => {
      this.onChangeCanvas();
      this.canvasHandlers.onSelect(null);
    },
    onModified: debounce(() => {
      this.forceUpdate();
      this.onChangeCanvas();
    }, 300),
    onZoom: (zoom) => {
      this.setState({ zoomRatio: zoom });
      this.props.dispatch(setShowZoomWatermark(false));
    },
    onChange: async (selectedItem, key, value, allValues) => {
      this.onChangeCanvas();
      const changedKey = key;
      const changedValue = value;

      if (allValues.workarea) {
        await this.canvasHandlers.onChangeWokarea(
          changedKey,
          changedValue,
          allValues.workarea
        );
        this.onChangeCanvas();
        return;
      }

      if (
        changedKey === "file" ||
        changedKey === "src" ||
        changedKey === "code"
      ) {
        if (selectedItem.type === "image") {
          this.canvasRef.handler.setImageById(selectedItem.id, changedValue);
        } else if (selectedItem.superType === "element") {
          this.canvasRef.handler.elementHandler.setById(
            selectedItem.id,
            changedValue
          );
        }
        return;
      }

      this.canvasRef.handler.drawingHandler.updateProperties(
        selectedItem,
        changedKey,
        changedValue,
        allValues
      );
      this.setState({ selectedItem: selectedItem });
      this.canvasRef.handler.transactionHandler.save("properties");
      this.canvasRef.handler.set(changedKey, selectedItem[changedKey]);
    },
    onChangeWokarea: async (changedKey, changedValue, allValues) => {
      if (changedKey === "layout") {
        this.canvasRef.handler.workareaHandler.setLayout(changedValue);
        return;
      }
      if (changedKey === "file" || changedKey === "src") {
        await this.canvasRef.handler.workareaHandler.setImage(changedValue);
        return;
      }
      if (changedKey === "width" || changedKey === "height") {
        this.canvasRef.handler.originScaleToResize(
          this.canvasRef.handler.workarea,
          allValues.width,
          allValues.height
        );
        this.canvasRef.canvas.centerObject(this.canvasRef.handler.workarea);
        return;
      }
      this.canvasRef.handler.workarea.set(changedKey, changedValue);
      this.canvasRef.canvas.requestRenderAll();
    },
    onMouseMove: (target) => {
    },
    onContext: (ref, event, target) => {
      if ((target && target.id === "workarea") || !target) return null;
      if (target.type === "activeSelection") {
        return (
          <Menu className="dropdown-object">
            <Menu.Item
              onClick={() => {
                this.canvasRef.handler.duplicate();
              }}
            >
              <i className="icon-Asset-917"></i>
              {i18n.t("mapeditor.actions.clone")}
            </Menu.Item>
            <Menu.Item
              onClick={() => {
                this.canvasRef.handler.remove();
              }}
            >
              <i className="icon-trash"></i>
              {i18n.t("mapeditor.actions.delete")}
            </Menu.Item>
          </Menu>
        );
      }
      if (target.type === "group") {
        return (
          <Menu className="dropdown-object">
            <Menu.Item
              onClick={() => {
                this.canvasRef.handler.duplicate();
              }}
            >
              <i className="icon-Asset-917"></i>
              {i18n.t("mapeditor.actions.clone")}
            </Menu.Item>
            <Menu.Item
              onClick={() => {
                this.canvasRef.handler.remove();
              }}
            >
              <i className="icon-trash"></i>
              {i18n.t("mapeditor.actions.delete")}
            </Menu.Item>
          </Menu>
        );
      }
      return (
        <Menu className="dropdown-object">
          <Menu.Item
            onClick={() => {
              this.canvasRef.handler.duplicateById(target.id);
            }}
          >
            <i className="icon-Asset-917"></i>
            {i18n.t("mapeditor.actions.clone")}
          </Menu.Item>
          <Menu.Item
            onClick={() => {
              this.canvasRef.handler.removeById(target.id);
            }}
          >
            <i className="icon-trash"></i>
            {i18n.t("mapeditor.actions.delete")}
          </Menu.Item>
        </Menu>
      );
    },
    onTransaction: (transaction) => {
      this.forceUpdate();
    },
    onZone: (exited) => {
      if (!exited) {
        this.setState({ selectedProperties: "default" });
        return;
      }
      this.setState({ selectedProperties: "node" });
      this.setState({ selectedItem: this.canvasRef.handler.activeZone });
      const { activeZone } = this.canvasRef.handler;
      this.canvasRef.handler.canvas.discardActiveObject();
      const objs = this.canvasRef.handler.canvas.getObjects().filter((obj) => obj.id !== activeZone.id);
      objs.map(obj => obj.set({ selectable: true, opacity: 1 }));
      const mapRows = this.canvasRef.canvas.getObjects("group").filter(obj => obj.superType === "row");
      if (mapRows.length > 0) {
        mapRows.forEach(mapRow => {
          const rowSeats = mapRow.getObjects("group");
          rowSeats.forEach(seat => {
            seat.set({
              selectable: true
            })
          });
        })
      }
      activeZone.set({
        lockMovementX: false,
        lockMovementY: false,
        selectable: true
      });
      activeZone.item(0).set({
        fill: activeZone.item(0).originalFill,
        originalFill: ''
      });
      activeZone.item(1).set({
        visible: true
      });
      this.canvasRef.canvas.requestRenderAll();
      const rowGroups = this.canvasRef.canvas.getObjects("group");
      const rows = rowGroups.filter(object => object.superType === "row");
      const zoneRows = rows.filter(row => row.zoneID === activeZone.id);
      if (zoneRows) {
        zoneRows.forEach(row => {
          row.set({
            visible: false
          })
          activeZone.addWithUpdate(row);
          this.canvasRef.canvas.remove(row);
        });
      }
      this.canvasRef.canvas.setActiveObject(activeZone);
      this.canvasRef.handler.drawingHandler.setType(activeZone.superType);
      this.canvasRef.handler.activeZone = undefined;
      this.canvasRef.canvas.requestRenderAll();
      this.onChangeCanvas();
    }
  };

  handlers = {
    onChangeSelectedProperties: (type, tool) => {
      this.setState({ selectedProperties: type });
      this.setState({ selectedItem: null });
      this.setState({ selectedTool: tool });
    },
    onChangePreview: (checked) => {
      if (checked) {
        const data = this.canvasRef.handler.exportJSON().filter((obj) => {
          return obj.id;
        });
        this.setState({
          preview: checked,
          objects: data,
        });
      } else {
        this.setState({
          preview: checked,
        });
      }
    },
    onProgress: (progress) => {
      this.setState({ progress });
    },
    onSaveImage: () => {
      this.canvasRef.handler.saveCanvasImage();
    },
    onExportToJson: () => {
      const objects = this.canvasRef.handler.exportJSON();

      // Helper para clonar todas las propiedades excepto las excluidas y omitir null/0/false si es conveniente
      const excludedProps = ["version", "resource", "link", "tooltip", "userProperty", "trigger", "shadow", "skewX", "skewY", "flipX", "flipY", "lineHeight", "globalCompositeOperation",
        "strokeLineCap", "strokeLineJoin", "strokeMiterLimit", "fillRule", "paintFirst", "textBackgroundColor", "backgroundColor", "styles"
      ];

      // Lista de booleanos que SIEMPRE deben guardarse aunque estén en false
      const alwaysIncludeFalse = [
        "selectable", "visible"
      ];
      const pickAll = (obj) => {
        const result = {};
        Object.keys(obj).forEach((key) => {
          if (excludedProps.includes(key)) return;
          if (obj[key] === null) return;

          // Propiedades visuales que deben guardarse aunque sean 0
          const zeroAllowed = [
            "left", "top", "angle", "width", "height", "radius", "fontSize", "charSpacing",
            "opacity", "strokeWidth", "fontWeight", "fontStyle", "fontFamily"];
          if (obj[key] === 0 && !zeroAllowed.includes(key)) return;

          // Omitir booleanos en false salvo los que están en alwaysIncludeFalse
          if (typeof obj[key] === "boolean" && obj[key] === false && !alwaysIncludeFalse.includes(key)) return;
          result[key] = obj[key];
        });
        return result;
      };

      // Recursivo para limpiar objetos anidados
      function clean(obj) {
        const o = pickAll(obj);
        if (Array.isArray(o.objects)) {
          let objectsToMap = o.objects;
          if (o.superType === ObjectSuperTypesEnum.Seat) {
            objectsToMap = objectsToMap.filter(child => {
              if ((child.type === "svg") && child.visible === false) {
                return false;
              }
              return true;
            });
          }

          o.objects = objectsToMap.map(child => {
            if (child.superType === ObjectSuperTypesEnum.Seat) return clean(child);
            if (child.superType === ObjectSuperTypesEnum.Row) return clean(child);
            if (child.superType === ObjectSuperTypesEnum.PolygonZone) return clean(child);
            if (child.superType === ObjectSuperTypesEnum.RectTable) return clean(child);
            if (child.superType === ObjectSuperTypesEnum.RoundTable) return clean(child);
            if (child.objects) return clean(child);
            return pickAll(child);
          });
        }
        return o;
      }

      const exportData = {
        objects: {
          rows: objects.filter((o) => o.superType === ObjectSuperTypesEnum.Row && o.objects.length > 0).map(o => clean(o)),
          polygonZones: objects.filter((o) => o.superType === ObjectSuperTypesEnum.PolygonZone).map(o => clean(o)),
          tables: objects.filter((o) => o.superType === ObjectSuperTypesEnum.RoundTable || o.superType === ObjectSuperTypesEnum.RectTable).map(o => clean(o)),
          otherObjects: objects.filter((o) => !validTypes.includes(o.superType)).map(o => clean(o)),
        },
        toolConfiguration: {
          rowSeatSpacing: this.props.rowSeatSpacing,
          rowSeatSize: this.props.rowSeatSize,
          rowSpacing: this.props.rowSpacing,
          roundTableSeats: this.props.roundTableSeats,
          roundTableRadius: this.props.roundTableRadius,
          rectTableSeats: this.props.rectTableSeats,
          rectTableDimensions: this.props.rectTableDimensions
        },
      };

      // Las propiedades de otherObjects ya están optimizadas en el patch anterior usando clean()
      return JSON.stringify(exportData);
    },
    onLoad: async ({
      Objects,
      ToolConfiguration: {
        RowSeatSpacing,
        RowSeatSize,
        RowSpacing,
        RoundTableSeats,
        RoundTableRadius,
        RectTableSeats,
        RectTableDimensions },
    }) => {
      if (Objects) {
        this.canvasRef.handler.clear(true);
        const data = Objects.filter((obj) => {
          return obj.id;
        });
        this.props.dispatch(setSeatSpacing(RowSeatSpacing));
        this.props.dispatch(setRowSeatSize(RowSeatSize));
        this.props.dispatch(setRowSpacing(RowSpacing ?? designerPropertiesSlice.getInitialState().rowSpacing));
        if (RoundTableSeats != null) {
          this.props.dispatch(setRoundTableSeats(RoundTableSeats));
        }
        if (RoundTableRadius != null) {
          this.props.dispatch(setRoundTableRadius(RoundTableRadius));
        }
        Object.entries(RectTableSeats ?? {}).forEach(([key, value]) => {
          this.props.dispatch(setRectTableSeats({ key, value }));
        });
        Object.entries(RectTableDimensions ?? {}).forEach(([key, value]) => {
          this.props.dispatch(setRectTableDimensions({ key, value }));
        });
        await this.canvasRef.handler.importJSON(data, "editor");
      }
    },
    onOpenModal: async () => {
      const maps = await service.map.getPublishedMaps();
      this.setState({ maps: maps });
      this.props.dispatch(openModal(true));
    }
  };

  shortcutHandlers = {
    esc: () => {
      document.addEventListener("keydown", (e) => {
        if (e.code === code.ESCAPE) this.handlers.onChangePreview(false);
      });
    },
  };

  onChangeCanvas = async () => {
    this.setProperties();
    const { map } = this.state;
    if (map.status == mapStatus.new) { // si es nuevo crea el mapa
      await this.saveMap(actionSaveMap.create);
      await this.saveMap(actionSaveMap.updateLayout);
      map.status = mapStatus.saved;
    } else { // si no es nuevo marca como modificado
      map.status = mapStatus.modified;
    }
  };

  setProperties = () => {
    const seats = getSeats(this.canvasRef.handler);
    const zones = this.canvasRef.handler.canvas.getObjects("group").filter(obj => obj.superType === "polygonZone");
    if (zones.length > 0) {
      zones.forEach(zone => {
        let rows = zone.getObjects("group").filter(obj => obj.superType === "row");
        if (rows.length > 0) {
          rows.forEach(row => {
            let seatsInZone = row.getObjects("group");
            if (seatsInZone.length > 0) {
              seats.push(...seatsInZone);
            }

          });
        }
      })
    }
    this.setState({
      validation: {
        duplicates: getDuplicates(seats),
        notCategorized: getNotCategorized(seats),
        unlabeled: getUnlabeled(seats),
        numberSeats: seats.length
      }
    });
    const { validation: { duplicates, notCategorized, unlabeled } } = this.state;
    if (seats.length > 0) {
      this.setMapValidation(duplicates.length === 0 && notCategorized.length === 0 && unlabeled.length === 0);
    }
  };

  setMapValidation = (available) => {
    this.props.dispatch(setAvailableToPublish(available));
  }

  render() {
    const {
      preview,
      selectedItem,
      selectedTool,
      zoomRatio,
      styles,
      objects,
      cursorName,
      itemOnCanvas,
      selectedProperties,
      maps,
      selectedMap
    } = this.state;

    const {
      onAdd,
      onRemove,
      onSelect,
      onModified,
      onChange,
      onZoom,
      onMouseMove,
      onContext,
      onTransaction,
      onZone,
    } = this.canvasHandlers;

    const {
      onChangePreview,
      onSaveImage,
      onChangeSelectedProperties,
      onOpenModal
    } = this.handlers;

    const screenCaptureAction = (
      <>
        <Tooltip
          title={i18n.t("mapeditor.actions.take-capture-screen")}
          placement="left"
        >
          <Button onClick={onSaveImage} className="btn__tool">
            <span className="icon-take-screen-captura"></span>
          </Button>
        </Tooltip>
      </>
    );

    const handleModalOk = async () => {
      this.props.dispatch(openModal(false));
      this.props.dispatch(setSpinning(true));
      let newMap = this.state.map;
      const mapSelected = await service.map.getById(this.state.selectedMap.key);
      if (!this.state.map.key) {
        await this.saveMap(actionSaveMap.create);
        newMap = this.state.map;
      }
      newMap.layout = mapSelected.layout;
      await this.loadMap(newMap, actionSaveMap.updateLayout);
      this.props.dispatch(setSpinning(false));
      const args = {
        message: 'Éxito',
        description:
          'El mapa ha sido cargado correctamente.',
        duration: 4,
        icon: <Icon type="smile" style={{ color: '#33FF85' }} />
      };
      notification.open(args);
    }

    const handleSelectChange = (value) => {
      const map = maps.find(map => map.key == value);
      this.setState({ selectedMap: map })
    }

    const handleModalCancel = () => {
      this.props.dispatch(openModal(false));
      this.setState({ selectedMap: {} });
    };

    const { Option } = Select;
    const { Title } = Typography;

    return (
      <Layout>
        <Header
          map={this.state.map}
          screenCaptureAction={screenCaptureAction}
          canvasRef={this.canvasRef}
          selectedItem={selectedItem}
          onSelect={onSelect}
          action={this.state.action}
          saveMap={this.saveMap}
          onChangeCanvas={this.onChangeCanvas}
          openModal={onOpenModal}
          onChangePreview={onChangePreview}
        />
        <div className="map">
          <article className="map-editor-toolbar">
            <ToolBar
              canvasRef={this.canvasRef}
              onChangeSelectedProperties={onChangeSelectedProperties}
            />
          </article>

          <article className="map-canvas-container">
            <div
              className="canvas-wrapper"
              onMouseEnter={() => this.props.dispatch(setShowZoomWatermark(true))}
              onMouseLeave={() => this.props.dispatch(setShowZoomWatermark(false))}
            >
              <Canvas
                ref={(c) => {
                  this.canvasRef = c;
                }}
                minZoom={10}
                maxZoom={1000}
                objectOption={defaultOption}
                propertiesToInclude={propertiesToInclude}
                onModified={onModified}
                onZone={onZone}
                onAdd={onAdd}
                onRemove={onRemove}
                onSelect={onSelect}
                onZoom={onZoom}
                onMouseMove={onMouseMove}
                onContext={onContext}
                onTransaction={onTransaction}
                keyEvent={{ transaction: true }}
                cursorName={cursorName}
                itemOnCanvas={itemOnCanvas}
                centerWorkarea={true}
              />
            </div>
            <div className="map-editor-footer-toolbar">
              <Footer
                canvasRef={this.canvasRef}
                zoomRatio={zoomRatio}
              />
            </div>
          </article>

          <article className="map-editor-properties-gral">
            <PropertyBar
              canvasRef={this.canvasRef}
              onChange={onChange}
              selectedItem={selectedItem}
              selectedTool={selectedTool}
              styles={styles}
              selectedProperties={selectedProperties}
              validation={this.state.validation}
            />
          </article>

          {preview &&
            <Preview
              onChangePreview={onChangePreview}
              objects={objects}
            />
          }
          <Modal
            visible={this.props.open}
            onOk={handleModalOk}
            onCancel={handleModalCancel}
            title={"Lista de Mapas"}
            okText={"Cargar"}
            cancelText={"Cancelar"}
          >
            <Select
              showSearch
              style={{ width: '100%' }}
              placeholder="Seleccione un Mapa"
              optionFilterProp="children"
              onChange={handleSelectChange}
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {maps.map(map => {
                return (<Option key={map.key} value={map.key}>{map.name}</Option>)
              })}
            </Select>
            <div style={{ display: "flex", alignItems: 'center', flexDirection: 'column' }}>
              {(selectedMap && selectedMap.imageUrl) && <Avatar style={{ margin: '10px' }} shape="square" size={150} src={selectedMap.imageUrl} />}
              {(selectedMap && selectedMap.imageUrl === "") &&
                <>
                  <Icon style={{ margin: '10px', fontSize: '100px' }} type="frown" />
                  <Title style={{ marginBottom: '0px' }} level={4}>Sin preview</Title>
                </>
              }
            </div>
          </Modal>
        </div>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    rowSeatSpacing: state.properties.rowSeatSpacing,
    rowSeatSize: state.properties.rowSeatSize,
    rowSpacing: state.properties.rowSpacing,
    open: state.properties.open,
    zoneActive: state.properties.zoneActive
  };
};

export default connect(mapStateToProps)(MapEditor);
